import { render } from "./AccountForm.vue?vue&type=template&id=49cbf644&scoped=true"
import script from "./AccountForm.vue?vue&type=script&lang=js"
export * from "./AccountForm.vue?vue&type=script&lang=js"

import "./AccountForm.vue?vue&type=style&index=0&id=49cbf644&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49cbf644"]])

export default __exports__